import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Muratpaşa Koltuk Yıkama", path: "/bayrampasa/muratpasa-koltuk-yikama" },
  { label: "Muratpaşa Yatak Yıkama", path: "/bayrampasa/muratpasa-yatak-yikama" },
  { label: "Terazidere Koltuk Yıkama", path: "/bayrampasa/terazidere-koltuk-yikama" },
  { label: "Terazidere Battaniye Yıkama", path: "/bayrampasa/terazidere-battaniye-yikama" },
  { label: "Yıldırım Mahallesi Koltuk Yıkama", path: "/bayrampasa/yildirim-koltuk-yikama" },
  { label: "Yıldırım Mahallesi Perde Yıkama", path: "/bayrampasa/yildirim-perde-yikama" },
  { label: "Kartaltepe Mahallesi Koltuk Yıkama", path: "/bayrampasa/kartaltepe-koltuk-yikama" },
  { label: "Kartaltepe Kuru Temizleme", path: "/bayrampasa/kartaltepe-kuru-temizleme" },
  { label: "Altıntepsi Koltuk Yıkama", path: "/bayrampasa/altintepsi-koltuk-yikama" },
  { label: "Altıntepsi Yerinde Yıkama", path: "/bayrampasa/altintepsi-yerinde-yikama" },
  { label: "Bayrampaşa Merkez Koltuk Yıkama", path: "/bayrampasa/merkez-koltuk-yikama" }
];

const BayrampasaServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          BAYRAMPAŞA HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default BayrampasaServiceArea;
